import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SettingsIcon from '@mui/icons-material/Settings';
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
} from '@mui/material';

export default function GroupSettingControl() {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleSettingIconClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSettingMenuClose = () => {
    setAnchorEl(null);
  };

  const handleGroupMemberMenuClick = () => {
    handleSettingMenuClose();
    navigate("/signal/group_members");
  };

  const handleUserTeamMenuClick = () => {
    handleSettingMenuClose();
    navigate("/signal/user_teams");
  };

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "right", justifyContent: "right", mr: 2 }}>
        <IconButton onClick={(e) => handleSettingIconClick(e)}>
          <SettingsIcon sx={{ fontSize: "36px", cursor: "pointer" }} />
        </IconButton>
      </Box>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleSettingMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={handleGroupMemberMenuClick}>メンバー管理</MenuItem>
        <MenuItem onClick={handleUserTeamMenuClick}>チーム管理</MenuItem>
      </Menu>
    </>
  )
}
